// import Select from "react-select";
// const customStyles = {
//   control: (provided) => ({
//     ...provided,
//     backgroundColor: "#1e293b", // input background
//     borderColor: "#1c2c46",
//     color: "white",
//   }),

//   singleValue: (provided) => ({
//     ...provided,
//     color: "white", // selected text color
//   }),

//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: "#1e293b", // dropdown background
//   }),

//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isFocused
//       ? "#3b82f6"   // hover color
//       : state.isSelected
//       ? "#2563eb"   // selected color
//       : "#1e293b",
//     color: "white",
//     cursor: "pointer",
//   }),

//   input: (provided) => ({
//     ...provided,
//     color: "white", // typing text color
//   }),

//   placeholder: (provided) => ({
//     ...provided,
//     color: "#94a3b8", // placeholder color
//   }),
// };
// const ViewTimeZone = ({ formData, handleChange, timeZones, loading }) => {

//   const options = timeZones.map(d => ({
//     value: d.value,
//     label: `${d.name} (${d.value})`
//   }));

//   return (
//     <div>
//       <label className="block mb-1 text-sm font-medium text-blue-200">
//         Select View TimeZone
//       </label>

//       <Select
//         options={options}
//         value={options.find(o => o.value === formData.viewtimezone)}
//         onChange={(selected) =>
//           handleChange({
//             target: {
//               name: "viewtimezone",
//               value: selected.value
//             }
//           })
//         }
//         isDisabled={loading}
//         isSearchable={true}
//         menuPlacement="auto"
//         styles={customStyles}
//       />
//     </div>
//   );
// };
// export default ViewTimeZone



import Select from "react-select";

// ─── Custom styles with theme support ──────────────────────────────────────
const getSelectStyles = (isDark) => ({
  control: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1e293b" : "#ffffff",
    borderColor: isDark ? "#1c2c46" : "#d1d5db",
    color: isDark ? "white" : "#1a1a2e",
    boxShadow: 'none',
    '&:hover': {
      borderColor: isDark ? "#3b82f6" : "#60a5fa",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: isDark ? "white" : "#1a1a2e",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1e293b" : "#ffffff",
    border: `1px solid ${isDark ? "#1c2c46" : "#d1d5db"}`,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? isDark ? "#3b82f6" : "#93c5fd"
      : state.isSelected
      ? isDark ? "#2563eb" : "#60a5fa"
      : isDark ? "#1e293b" : "#ffffff",
    color: isDark ? "white" : "#1a1a2e",
    cursor: "pointer",
    '&:hover': {
      backgroundColor: isDark ? "#3b82f6" : "#93c5fd",
      color: "white",
    },
  }),
  input: (provided) => ({
    ...provided,
    color: isDark ? "white" : "#1a1a2e",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: isDark ? "#94a3b8" : "#6b7280",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1c2c46" : "#d1d5db",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: isDark ? "#94a3b8" : "#6b7280",
    '&:hover': {
      color: isDark ? "#ffffff" : "#1a1a2e",
    },
  }),
});

const ViewTimeZone = ({ formData, handleChange, timeZones, loading, theme }) => {
  const isDark = theme === 'dark';
  const customStyles = getSelectStyles(isDark);

  const options = timeZones.map(d => ({
    value: d.value,
    label: `${d.name} (${d.value})`
  }));

  // Theme-aware classes
  const labelColor = isDark ? 'text-blue-200' : 'text-gray-700';

  return (
    <div>
      <label className={`block mb-1 text-sm font-medium ${labelColor}`}>
        Select View TimeZone
      </label>

      <Select
        options={options}
        value={options.find(o => o.value === formData.viewtimezone)}
        onChange={(selected) =>
          handleChange({
            target: {
              name: "viewtimezone",
              value: selected.value
            }
          })
        }
        isDisabled={loading}
        isSearchable={true}
        menuPlacement="auto"
        styles={customStyles}
        placeholder="Search timezone..."
      />
    </div>
  );
};

export default ViewTimeZone;